// extracted by mini-css-extract-plugin
module.exports = {"root":"Arrow-root-140f6d73dc250d90eb1ef3ce9b84b80a","colorDark":"Arrow-colorDark-634271dc5f80fe23644464db37ab175f"};